<template>
  <input
    v-model="date"
    :name="name"
    type="date"
    class="textInput"
    autocomplete="on"
    :lang="countryStore.locale"
  />
</template>

<script setup>
import { useCountryStore } from "~~/stores/country";

const countryStore = useCountryStore();

const date = ref(null);

const emit = defineEmits(["input"]);

const props = defineProps({
  defaultValue: {
    type: Date,
    default: null,
  },
  name: {
    type: String,
    required: false,
  },
});

watch(
  () => props.defaultValue,
  (value) => {
    try {
      date.value = value.toISOString().slice(0, 10);
    } catch {}
  },
  { immediate: true }
);

watch(date, (newValue) => {
  if (newValue) {
    emit("input", newValue);
  }
});
</script>

<style scoped lang="scss">
.textInput {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 3rem;
  box-sizing: border-box;
  -webkit-appearance: none;
  appearance: none;
  background: white;
  color: var(--black);
}
</style>
